import React, { useRef, RefObject } from 'react';
import { FacebookShareButton } from 'react-share';
import { Button, Img } from 'components/base';
import {
  Container,
  ButtonInner,
  ButtonLabel,
  Dropdown,
  DropdownIconContainer,
  FacebookShareButton as StyledFacebookShareButton,
  CopyButton,
} from './style';

import Language from 'constants/Language';

export interface Props {
  hideDropdown: boolean;
  toggleShareDropdown(): void;
  currentUrl: string;
  handleCopyCurrentUrl(containerRef: RefObject<HTMLDivElement>): void;
}

const ShareButton = (props: Props) => {
  const containerRef = useRef<HTMLDivElement>(null);
  const {
    hideDropdown,
    toggleShareDropdown,
    currentUrl,
    handleCopyCurrentUrl,
  } = props;

  const handleClickCopy = () => {
    handleCopyCurrentUrl(containerRef);
    toggleShareDropdown();
  };

  return (
    <Container ref={containerRef} position="relative">
      <Button
        ariaLabel={Language.t('ArticleUserStory.shareButtonAriaLabel')}
        onClick={toggleShareDropdown}
      >
        <ButtonInner>
          <Img
            alt={Language.t('ArticleUserStory.shareButtonAriaLabel')}
            src="/images/share-icon-sm.svg"
          />
          <ButtonLabel>{Language.t('ArticleUserStory.share')}</ButtonLabel>
        </ButtonInner>
      </Button>
      <Dropdown
        hideDropdown={hideDropdown}
        p={1.25}
        position="absolute"
        left={0}
        top="1.5rem"
      >
        <StyledFacebookShareButton
          as={FacebookShareButton}
          url={currentUrl}
          onClick={toggleShareDropdown}
          tabIndex={hideDropdown ? -1 : undefined}
          aria-label={Language.t('ArticleUserStory.shareToFacebook')}
        >
          <DropdownIconContainer>
            <Img src="/images/facebook-icon-blue.svg" alt="" />
          </DropdownIconContainer>
          <ButtonLabel>{Language.t('ArticleUserStory.facebook')}</ButtonLabel>
        </StyledFacebookShareButton>
        <CopyButton
          as={Button}
          display="flex"
          alignItems="center"
          ariaLabel={Language.t('ArticleUserStory.copyUrlAriaLAbel')}
          onClick={handleClickCopy}
          tabIndex={hideDropdown ? -1 : undefined}
        >
          <DropdownIconContainer>
            <Img src="/images/copy-link-icon-blue.svg" alt="" />
          </DropdownIconContainer>
          <ButtonLabel>{Language.t('ArticleUserStory.copyLink')}</ButtonLabel>
        </CopyButton>
      </Dropdown>
    </Container>
  );
};

export default ShareButton;
